<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { accreditationsApi, type Accreditation } from '@/services/api/emsl';
import { useAppConfirm } from '@/composables/confirm';

const items = ref<Accreditation[]>([]);
const newName = ref('');
const confirm = useAppConfirm();

async function reload(): Promise<void> {
  items.value = await accreditationsApi.index();
}

async function create(): Promise<void> {
  if (newName.value.length === 0) return;
  const created = await accreditationsApi.create({ name: newName.value });
  items.value = [...items.value, created];
  newName.value = '';
}

async function remove(item: Accreditation): Promise<void> {
  const ok = await confirm({ header: 'Remove Accreditation', message: `Remove "${item.name}"?` });
  if (!ok) return;
  await accreditationsApi.remove(item.id);
  items.value = items.value.filter((i) => i.id !== item.id);
}

onMounted(reload);
</script>

<template>
  <section class="resource">
    <h1>Accreditations</h1>
    <form class="resource__new" @submit.prevent="create">
      <input v-model="newName" type="text" placeholder="Accreditation name" required />
      <button type="submit">Add</button>
    </form>
    <ul class="resource__list">
      <li v-for="a in items" :key="a.id">
        <span>{{ a.name }}</span>
        <button type="button" @click="remove(a)">Remove</button>
      </li>
    </ul>
    <p v-if="items.length === 0">No accreditations.</p>
  </section>
</template>

<style scoped src="@/assets/styles/resource-list.scss"></style>
